// extracted by mini-css-extract-plugin
export default {"List":"ul5xoHhegJRchzu_twSB","ListEmpty":"POswtJcMBin2ypiS6Kn5","Consumers":"k3IdoFWT7KRLwBDq00Tj","Button":"oS9K8Oum7EHV7oO_L_vV","EmptyText":"GUX8smYigeyHDM3qoW1y"};